import './style.scss';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import useCards from '../../../pctHooks/useCards';
import SVG from 'react-inlinesvg';
import useSrcSetVerify from '../../../pctHooks/useSrcSetVerify';

import { updatePreTest } from 'actions';

import {
    Duration,
    Label,
    Text,
    ProgressBar,
    Image,
    Mandatory,
    Sequential,
    ButtonCertificate,
    Registered,
    Like,
    ViewSyllabus,
    Preloader,
    EnrollmentProcessing,
} from '../../atoms';
import { useParams } from 'react-router-dom';
import ShareButton from 'pctComponents/organisms/ShareButton';
import { getProfileInfo } from 'services/utils';
import ModalEquivalencyPages from 'pctComponents/modals/ModalEquivalencyPages';
import NiceModal from '@ebay/nice-modal-react';
import { getEquivalences } from 'services/api';
import { Button } from 'react-bootstrap';

import { PreTestSVG } from '../../svg';
import BadgeNewContent from 'pctComponents/BadgeNewContent';
import {
    EvaluationKnowledgeGradeText,
    EvaluationKnowledgeRetry,
    getEvaluationKnowledgeCardInfo,
} from '../EvaluationKnowledgeCardInfo';

type idType = {
    id?: string;
};

type Props = {
    id: any;
    dataParent?: any;
    prerequisite?: boolean;
    collection: any;
    parameters?: any;
    preTest?: any;
    configPreTest?: {
        statusPreTest: Boolean | null;
    };
};

const CardBlock = (props: Props) => {
    const { collection, dataParent, preTest } = props;

    const { description, title, workload, mandatory } = collection.data;
    const { id } = useParams<idType>();
    const { equivalentNodeCode } = collection?.data?.nodeEnrollment || {};
    const hasEquivalence = Boolean(equivalentNodeCode);
    const setProgressStateRef = useRef(null as any);
    const progressInfoRef = useRef(null as any);
    const user = getProfileInfo();

    const {
        image,
        concluidedText,
        currentLabel,
        currentBreadText,
        isEnrollment,
        hasCertificate,
        initialProgressState,
        statusRegistered,
        classNotStartedYet,
        prerequisitesMet,
        handleCardMouseEvent,
        handleCertificateMouseEvent,
        statusElement,
        hasEnrollment,
        verifyCompletedStatus,
        nodeAvailable,
        preRequisiteBlockMet,
        updateProcessing,
        processingStatus,
    } = useCards({
        collection,
        id,
        dataParent,
        setProgressStateRef,
        progressInfoRef,
        preTest,
    });

    const configPreTest = props.configPreTest?.statusPreTest || false;

    const mandatoryStatus = !!mandatory;
    const [progressInfo, setProgressState] = useState(initialProgressState());
    const [equivalencePages, setEquivalencePages] = useState([]);
    const [loadingEquivalencies, setLoadingEquivalencies] = useState(false);

    useEffect(() => {
        (async () => {
            if (!hasEquivalence) {
                return;
            }

            setLoadingEquivalencies(true);
            try {
                const {
                    data: { result },
                } = await getEquivalences(collection?.data?.idNode || 0);
                setEquivalencePages(result.map((page) => ({ title: page.origin.title })));
                setLoadingEquivalencies(false);
            } catch (error) {
                setLoadingEquivalencies(false);
            }
        })();
    }, [collection, equivalentNodeCode, user.idUser, hasEquivalence]);

    setProgressStateRef.current = setProgressState;
    progressInfoRef.current = progressInfo;

    const stsEnrollment = hasEnrollment() && collection.data?.nodeType !== 'ORGANIZATION';
    const showNewBadge = collection?.newlyAvailable;
    const textBadge = collection?.newContentInternal ? 'Novo' : 'Novos conteúdos';
    const evaluationKnowledgeInfo = getEvaluationKnowledgeCardInfo(collection);

    const format = 'landscape-xsmall';
    const imgBase = (statusElement() === 'ARCHIVED' || !nodeAvailable()) && image().image ? image().image : image();

    const srcSetVerify = useSrcSetVerify(imgBase, format);
    const hasCollectionImage = !!collection.data.image;
    const shouldShowThumb =
        collection.elementType !== 'EVALUATION' &&
        statusElement() !== 'ARCHIVED' &&
        (hasCollectionImage ? nodeAvailable() !== false : nodeAvailable());

    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;

    const isYouTubeLink = (link) => {
        return youtubeRegex.test(link);
    };

    const showEquivalenceModal = async () => {
        NiceModal.show(ModalEquivalencyPages, {
            obj: {
                pages: equivalencePages,
            },
        });
    };


    const handleCard = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }
        handleCardMouseEvent(e);
    };

    const handleEquivalence = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        if (hasEquivalence) {
            showEquivalenceModal();
        }

        e.stopPropagation();
    };

    const handleCertificate = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        handleCertificateMouseEvent(e);
    };

    

    if (loadingEquivalencies) {
        return <Preloader />;
    }

    return (
        <div
            className={`pctMolecule pctCard pctCardBlock 
            ${
                preRequisiteBlockMet === true ||
                prerequisitesMet() === false ||
                statusRegistered() === 'inactive' ||
                statusElement() === 'ARCHIVED' ||
                classNotStartedYet()
                    ? 'pctCardBlockLock'
                    : ''
            }
            ${!nodeAvailable() ? 'pctCardBlockLock02' : ''}`}
            style={{
                cursor: processingStatus ? 'not-allowed' : 'pointer',
            }}
            onClick={handleCard}
        >
            {shouldShowThumb && (
                <div className="thumbContainer">
                    <Registered status={statusRegistered()} />
                    <div className="thumb" data-aspectratio={format}>
                        {showNewBadge && <BadgeNewContent text={textBadge} />}
                        {hasCollectionImage ? (
                            <Image path={srcSetVerify || image()} pathSet={srcSetVerify} />
                        ) : (
                            image() && <SVG src={image()} />
                        )}
                        <EnrollmentProcessing
                            processing={processingStatus}
                            collection={collection}
                            updateProcessing={updateProcessing}
                        />
                    </div>
                </div>
            )}

            {/* Verificacao do tipo EVALUATION */}
            {collection.elementType === 'EVALUATION' && (
                <div className="thumbContainer">
                    <Registered status={statusRegistered()} />
                    <div
                        className={`thumb evaluationKnowledgeThumb ${
                            evaluationKnowledgeInfo.evaluationQuestionnaireInit
                                ? 'evaluationKnowledgeThumbHighlighted'
                                : ''
                        }`}
                        data-aspectratio={format}
                    >
                        {showNewBadge && <BadgeNewContent text={textBadge} />}
                        <div className="evaluationKnowledgeThumbMedia">
                            {collection.data.image && !preTest ? (
                                <Image path={image()} pathSet={srcSetVerify} />
                            ) : (
                                <SVG src={preTest ? PreTestSVG() : image()} />
                            )}
                        </div>
                        <EvaluationKnowledgeRetry info={evaluationKnowledgeInfo} />
                    </div>
                </div>
            )}

            {statusElement() === 'ARCHIVED' && (
                <div className="thumbContainer">
                    <div className="thumb" data-aspectratio={format}>
                        {showNewBadge && <BadgeNewContent text={textBadge} />}
                        {image().svg && <SVG src={image().svg} />}

                        {!collection.data.image && (
                            <div className="thumb">{image() && <SVG src={image().image} />}</div>
                        )}

                        {collection.data.image && (
                            <Image path={image().image} pathSet={srcSetVerify} placeholder={true} />
                        )}
                    </div>
                </div>
            )}

            {!nodeAvailable() && (
                <div className="thumbContainer">
                    <div className="thumb" data-aspectratio={format}>
                        {showNewBadge && <BadgeNewContent text={textBadge} />}
                        {image().svg && <SVG src={image().svg} />}

                        {/* {!collection.data.image &&
              <div className="thumb">{image() && <SVG src={image().image} />}</div>
            } */}

                        {collection.data.image && (
                            <Image path={image().image} pathSet={srcSetVerify} placeholder={true} />
                        )}
                        <div className="cardInfo">
                            <h3>Acesso Restrito</h3>
                            <p>
                                Este <span className="destaque">conteúdo é restrito</span> para um grupo específico e
                                você não tem permissão para visualizar.
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div
                className={`infosContainer 
        ${!image() ? 'infosContainerImgNull' : ''}
        ${!stsEnrollment ? 'infosContainerEnrollmentNull' : ''}
        
        `}
            >
                {<Text text={currentBreadText()} component={'small'} className="breadCard" />}
                {<Text component="h3" text={title} />}
                {description &&
                    description !== 'N / A' &&
                    description !== 'N / D' &&
                    description !== 'N/A' &&
                    description !== 'N/D' && <Text component="p" text={description} />}

                {stsEnrollment && (
                    <div className="progressConatainer">
                        <ProgressBar
                            collection={collection}
                            percentage={progressInfo}
                            status={!preTest ? statusElement() : ''}
                        />
                    </div>
                )}

                <div className="footerInfos">
                    <div className="leftInfo">
                        {<Label text={currentLabel()} className="label" />}
                        {
                            <div className="dataInfos">
                                {<Duration text={workload} timeFormat={'seconds'} className="duration-mobile" />}

                                {stsEnrollment && statusElement() !== 'ARCHIVED' && (
                                    <Button
                                        className={hasEquivalence ? 'clickable-label' : ''}
                                        onClick={handleEquivalence}
                                    >
                                        {evaluationKnowledgeInfo.isKnowledgeEvaluation &&
                                        evaluationKnowledgeInfo.hasFinishedEvaluation ? (
                                            <EvaluationKnowledgeGradeText
                                                info={evaluationKnowledgeInfo}
                                                className="dis"
                                            />
                                        ) : (
                                            <Text component="small" className="dis" text={concluidedText()} />
                                        )}
                                    </Button>
                                )}
                                <div className="info-buttons">
                                    {hasCertificate() && (
                                        <ButtonCertificate
                                            verifyCompletedStatus={verifyCompletedStatus()}
                                            onClick={handleCertificate}
                                        />
                                    )}

                                    <ViewSyllabus collection={collection} />

                                    <Like
                                        css={{
                                            cursor: processingStatus ? 'not-allowed' : 'pointer',
                                        }}
                                        disabled={processingStatus || !!configPreTest}
                                        collection={collection}
                                        statusRegistered={statusRegistered()}
                                        className={`likeSmall ${processingStatus || !!configPreTest ? 'inactive' : ''}`}
                                    />
                                </div>
                            </div>
                        }
                    </div>

                    {/* {(star || award)&&<div className='rightInfo'>
                        <div className='baseInfo'>
                            {<Star text={star} />}
                            {<Award text={award} />}
                        </div>
                    </div>} */}
                </div>
            </div>

            {statusElement() !== 'ARCHIVED' && (
                <div className="containerMandatoryLock">
                    {isYouTubeLink(collection.data.contentLocation) && Boolean(collection.data.shareable) ? (
                        <ShareButton
                            className="ShareButtonCardStandard"
                            callEvent={(e) => (processingStatus ? () => {} : e.stopPropagation())}
                            link={collection.data.contentLocation}
                            idContent={collection.idElement}
                            idUser={user.idUser}
                        />
                    ) : (
                        <></>
                    )}
                    <Mandatory status={mandatoryStatus} />
                    <Sequential
                        status={
                            !processingStatus &&
                            prerequisitesMet() &&
                            !preRequisiteBlockMet &&
                            statusRegistered() !== 'inactive' &&
                            !classNotStartedYet()
                        }
                    />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (store) => ({
    configPreTest: store.configPreTestState,
});

const mapDispatchToProps = (dispatch) => ({
    updatePreTest: (item) => dispatch(updatePreTest(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardBlock);
